// Vendors
import $ from 'jquery';
import { AJAX_URL } from './config';
import validator from 'validator';
import { errorHighlighting } from './apps/components/helpers';

// ---------------------------
// INIT
// ---------------------------

const signUpFormContainer = document.getElementById('sign-up-form');
const loadingSpinner = document.getElementById('loading-spinner');
init();
let emailIsError;

function showSpinner() {
  loadingSpinner.style.display = 'block';
}

function hideSpinner() {
  loadingSpinner.style.display = 'none';
}

function scrollToForm() {
  signUpFormContainer.scrollIntoView({
    behavior: 'smooth'
  });
}

function init() {
  const registrationData = JSON.parse(localStorage.getItem('registration'));
  let formPart = 1;
  if (registrationData) formPart = ++registrationData.lastFormPartCompleted;
  getSignUpFormPart(formPart);
}

// ---------------------------
// EVENT LISTENERS
// ---------------------------

function addEventListeners() {
  const formEl = document.querySelector('.form');
  const formPart = formEl.dataset.formPart;
  const inputEls = formEl.querySelectorAll('.form__input');
  const selectEls = formEl.querySelectorAll('.form__select');
  const radioEls = formEl.querySelectorAll('.form__radio');
  const fieldElements = [...inputEls, ...selectEls, ...radioEls];

  // add error highlighting on change
  fieldElements.forEach((element) => {
    element = element.tagName === 'DIV' ? element.firstElementChild : element;
    element.addEventListener('change', (event) => {
      const target = event.target.name;
      const value = event.target.value;
      const error = value ? false : true;
      errorHighlighting({ field: target, error });
    });
  });

  if (formPart == 1) {
    getStates();
    getRegions();

    // occupation field
    const occupationSelect = document.getElementById('occupation');
    occupationSelect.addEventListener('change', (event) => {
      const otherDiv = document.getElementById('occupation_other_div');
      otherDiv.style.display =
        event.target.value === 'Other' ? 'block' : 'none';
    });

    // under 18 field
    const ageRadios = document.querySelectorAll(
      'input[type=radio][name=age_18_or_older]'
    );
    ageRadios.forEach((radio) => {
      radio.addEventListener('change', (event) => {
        const parentDiv = document.getElementById('parent_on_team_div');
        parentDiv.style.display =
          event.target.value === 'Yes' ? 'none' : 'block';
      });
    });

    // email address field
    const emailInput = document.getElementById('email');

    emailInput.addEventListener('keyup', (event) => {
      getEmailExists(event.target.value, (emailExistsResponse) => {
        handleEmailValidation(emailExistsResponse);
      });
    });
  }

  if (formPart == 2) {
    // draggable importance ranking
    $('#importance-rank').sortable({
      placeholder: 'ui-state-highlight',
      forcePlaceholderSize: true
    });
    $('#importance-rank').disableSelection();

    // event participation checkboxes
    const eventParticipationOtherCheckbox = document.querySelector(
      'input[name="event_participation"][value=Other]'
    );
    eventParticipationOtherCheckbox.addEventListener('change', (event) => {
      const eventParticipationOtherDiv = document.getElementById(
        'event_participation_other_div'
      );
      eventParticipationOtherDiv.style.display = event.target.checked
        ? 'block'
        : 'none';
    });

    // beef in diet radio buttons
    const beefInDietDiv = document.getElementById('beef_in_diet');
    beefInDietDiv.addEventListener('click', (event) => {
      const beefInDietOther = document.getElementById('beef_in_diet_other_div');
      if (event.target.name === 'beef_in_diet') {
        beefInDietOther.style.display =
          event.target.value === 'Other' ? 'block' : 'none';
      }
    });

    // beef industry level radio buttons
    const beefIndustryLevelDiv = document.getElementById('beef_industry_level');
    beefIndustryLevelDiv.addEventListener('click', (event) => {
      const beefIndustryOther = document.getElementById(
        'beef_industry_level_other_div'
      );
      if (event.target.name === 'beef_industry_level') {
        beefIndustryOther.style.display =
          event.target.value === 'Other' ? 'block' : 'none';
      }
    });

    // family on team
    const familyOnTeamDiv = document.getElementById('family_on_team');
    familyOnTeamDiv.addEventListener('click', (event) => {
      const familyOnTeamSelected = document.getElementById(
        'family_on_team_selected_div'
      );
      if (event.target.name === 'family_on_team') {
        familyOnTeamSelected.style.display =
          event.target.dataset.value === 'Yes' ? 'block' : 'none';
      }
    });
  }

  if (formPart == 3) {
    // jersey size
    const jerseySizeSelect = document.getElementById('jersey_size');
    jerseySizeSelect.addEventListener('change', (event) => {
      const otherDiv = document.getElementById('jersey_size_other_div');
      otherDiv.style.display =
        event.target.value === 'Other' ? 'block' : 'none';
    });

    // source
    const sourceSelect = document.getElementById('source');
    sourceSelect.addEventListener('change', (event) => {
      const otherDiv = document.getElementById('source_other_div');
      otherDiv.style.display =
        event.target.value === 'Other' ? 'block' : 'none';
    });
  }

  if (formPart == 4) {
    // public profile disclaimer
    const publicProfileField = document.getElementById('public_profile');
    publicProfileField.addEventListener('click', (event) => {
      const publicProfileInfo = document.getElementById('public_profile_info');
      if (event.target.name === 'public_profile') {
        publicProfileInfo.style.display =
          event.target.value == 1 ? 'block' : 'none';
      }
    });

    // publish on site disclaimer
    const publishOnSiteField = document.getElementById('publish_on_site');
    publishOnSiteField.addEventListener('click', (event) => {
      const publishOnSiteInfo = document.getElementById('publish_on_site_info');
      if (event.target.name === 'publish_on_site') {
        publishOnSiteInfo.style.display =
          event.target.value == 1 ? 'block' : 'none';
      }
    });
  }

  // form submission
  formEl.addEventListener('submit', (event) => {
    event.preventDefault();
    let formPart = event.target.dataset.formPart;
    const formData = new FormData(event.target);
    formData.append('lastFormPartCompleted', formPart);

    // get set of keys
    let keys = [];
    for (const key of formData.keys()) keys.push(key);
    keys = [...new Set(keys)];

    // handle multiples checked/selected
    const formDataObj = {};
    keys.forEach((key) => {
      let entries = formData.getAll(key);
      if (entries.length === 1) entries = formData.get(key);
      formDataObj[key] = entries;
    });

    // validate and save
    const isValid = validateFields(formPart, formDataObj);
    if (isValid) {
      saveToLocalStorage(formDataObj);
      formPart != 4 ? getSignUpFormPart(++formPart) : submitRegistration();
      scrollToForm();
    }
  });
}

// form validation
const validateFields = (formPart, formDataObj) => {
  let requiredFields;

  if (formPart == 1) {
    requiredFields = [
      'first_name',
      'last_name',
      'email',
      'phone',
      'home_address',
      'city',
      'state',
      'zip',
      'region',
      'occupation',
      'age_18_or_older',
      'dob'
    ];

    if (formDataObj?.occupation === 'Other') {
      requiredFields.push('occupation_other');
    }

    if (formDataObj?.age_18_or_older === 'No') {
      requiredFields.push('parent_on_team');
    }
  }

  if (formPart == 2) {
    requiredFields = [
      'athletic_background',
      'event_participation',
      'beef_in_diet',
      'beef_industry_level',
      'past_applicant',
      'children_interested',
      'family_on_team'
    ];

    if (formDataObj?.event_participation?.includes('Other')) {
      requiredFields.push('event_participation_other');
    }

    if (formDataObj?.beef_in_diet === 'Other') {
      requiredFields.push('beef_in_diet_other');
    }

    if (formDataObj?.beef_industry_level === 'Other') {
      requiredFields.push('beef_industry_level_other');
    }

    const familyOnTeam = formDataObj?.family_on_team ?? '';
    if (!familyOnTeam.search('Yes')) {
      requiredFields.push('family_on_team_selected');
    }
  }

  if (formPart == 3) {
    requiredFields = ['jersey_style', 'jersey_size', 'source'];

    if (formDataObj?.jersey_size === 'Other') {
      requiredFields.push('jersey_size_other');
    }

    if (formDataObj?.source === 'Other') {
      requiredFields.push('source_other');
    }
  }

  if (formPart == 4) {
    requiredFields = [
      'no_monetary_reiumbursement_agreement',
      'public_profile',
      'publish_on_site',
      'share_email_address'
    ];
  }

  let errorsList = [];
  requiredFields.forEach((field) => {
    const fieldError = { field, error: true };

    if (!!formDataObj[field]) {
      const originalField = formDataObj[field];
      let fieldIsEmpty;

      if (typeof originalField === 'object') {
        formDataObj[field] = JSON.stringify(originalField);
      }

      // redefine after object conversion if necessary
      fieldIsEmpty = validator.isEmpty(formDataObj[field]);

      fieldError.error = fieldIsEmpty ? true : false;

      // check if email already exists
      if (field === 'email' && !fieldIsEmpty) {
        fieldError.error = emailIsError;
      }

      formDataObj[field] = originalField;
    }
    errorsList.push(fieldError);
  });

  errorsList.forEach((error, idx) => {
    errorHighlighting({ field: error.field, error: error.error });
  });

  let valid = true;
  errorsList.every((error, idx) => {
    if (error.error) {
      valid = false;
      return false;
    }
    return true;
  });

  return valid;
};

// ---------------------------
// AJAX CALLS
// ---------------------------

// get sign up form
function getSignUpFormPart(part = 1) {
  $.ajax({
    url: `${AJAX_URL}wlGetSignUpFormPart`,
    method: 'POST',
    data: { part },
    dataType: 'html',
    beforeSend: () => showSpinner(),
    success: (res) => {
      signUpFormContainer.innerHTML = res;
      addEventListeners();
    },
    error: (res) => (signUpFormContainer.innerHTML = 'Please try again.'),
    complete: () => hideSpinner()
  });
}

function getRegions() {
  $.ajax({
    url: `${AJAX_URL}wl_get_all_regions`,
    method: 'GET',
    success: (res) => {
      const regionSelectEl = document.getElementById('region');
      const regions = res.data;
      regions.forEach((region) => {
        const opt = document.createElement('option');
        opt.value = region.term_id;
        opt.innerHTML = region.name;
        regionSelectEl.append(opt);
      });
    }
  });
}

function getStates() {
  $.ajax({
    url: `${AJAX_URL}wl_get_states_for_account_settings`,
    method: 'GET',
    success: (res) => {
      const stateSelectEl = document.getElementById('state');
      const states = res.data;
      states.forEach((state) => {
        const opt = document.createElement('option');
        opt.value = state;
        opt.innerHTML = state;
        stateSelectEl.append(opt);
      });
    }
  });
}

function getEmailExists(emailAddress, callback) {
  $.ajax({
    url: `${AJAX_URL}wl_get_email_exists`,
    method: 'POST',
    data: { emailAddress },
    success: (res) => {
      callback(res);
    }
  });
}

// ---------------------------
// HANDLER FUNCTIONS
// ---------------------------

function handleEmailValidation(response) {
  const $emailFormHelp = document.getElementById('email-form-notice');

  const isError = () => {
    $emailFormHelp.classList.remove('notice--success');
    $emailFormHelp.classList.remove('u--display-none');
    $emailFormHelp.classList.add('notice--error');
    $emailFormHelp.lastElementChild.textContent = response.data.message;
    emailIsError = true;
    errorHighlighting({ field: 'email', error: true });
  };

  const isSuccess = () => {
    $emailFormHelp.classList.remove('notice--error');
    $emailFormHelp.classList.add('u--display-none');
    $emailFormHelp.lastElementChild.textContent = response.data.message;
    emailIsError = false;
    errorHighlighting({ field: 'email', error: false });
  };

  // show notice and display message
  $emailFormHelp.style.display = 'flex';
  $emailFormHelp.lastElementChild.textContent = response.data.message;

  // toggle error and success
  response.success && !response.data.email_exists ? isSuccess() : isError();
}

function saveToLocalStorage(data) {
  const registrationData = JSON.parse(localStorage.getItem('registration'));
  const newRegistrationData = { ...registrationData, ...data };
  localStorage.setItem('registration', JSON.stringify(newRegistrationData));
}

function submitRegistration() {
  const registrationData = JSON.parse(localStorage.getItem('registration'));

  $.ajax({
    url: `${AJAX_URL}wlSaveSignUpFormData`,
    method: 'POST',
    data: registrationData,
    beforeSend: () => showSpinner(),
    success: (res) => {
      signUpFormContainer.innerHTML =
        '<div class="notice notice--success notice--column" data-notice-dismissible="false">' +
        '<h6 class="notice__title">Success</h6>' +
        '<p class="notice__message">Thank you for registering for the Texas Beef Team! We will be in touch with further details once your application has been processed.</p>' +
        '</div>';
    },
    error: (res) =>
      (signUpFormContainer.innerHTML =
        '<div class="notice notice--error notice--column" data-notice-dismissible="false">' +
        '<h6 class="notice__title">Error</h6>' +
        '<p class="notice__message">Something went wrong. Please try again.</p>' +
        '</div>'),
    complete: () => hideSpinner()
  });

  // clear registration data
  localStorage.removeItem('registration');
}
